/** @format */
import {IconFillProps} from './model';

const IconKPI = ({fill}: IconFillProps) => (
  <svg width='22' height='10' viewBox='0 0 22 10' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <path
      d='M21.4402 3.23705C21.5712 2.99391 21.4802 2.69068 21.2371 2.55976L17.2749 0.426315C17.0318 0.295396 16.7286 0.386365 16.5976 0.629501C16.4667 0.872636 16.5577 1.17587 16.8008 1.30679L20.3227 3.20319L18.4263 6.72507C18.2954 6.96821 18.3864 7.27144 18.6295 7.40236C18.8726 7.53327 19.1759 7.44231 19.3068 7.19917L21.4402 3.23705ZM1.14367 9.47891L21.1437 3.47891L20.8563 2.52109L0.856326 8.52109L1.14367 9.47891Z'
      fill={fill}
    />
  </svg>
);

export default IconKPI;
